export const SubscriptionRequestInitialValues = {
  search: '',
};
